import { TeeTime } from './TeeTime'

export function sortTeeTimes(teeTimes: TeeTime[]): TeeTime[] {
  return [...teeTimes].sort(
    (first, second) => first.time.getTime() - second.time.getTime()
  )
}
